<script>
import options from './ProductsCardsSlider.options'
export default options
</script>

<template>
  <article
    class="kb-products-cards-slider"
    aria-roledescription="carousel"
    aria-describedby="products-cards-slider-title"
    ref="componentRootEl"
  >
    <h2
      class="kb-products-cards-slider__title"
      id="products-cards-slider-title"
    >
      {{ getLabel('productsCardsSliderTitle') }}
    </h2>

    <div :id="sliderId" class="glide">
      <div class="kb-products-cards-slider__controls" data-glide-el="controls">
        <button
          class="kb-products-cards-slider__arrow"
          data-glide-dir="<"
          aria-controls="products-cards-slider-slides"
          aria-label="Forrige"
        >
          <div class="kb-ui-icon kb-ui-icon--ui-chevron-down"></div>
        </button>
        <button
          class="kb-products-cards-slider__arrow"
          data-glide-dir=">"
          aria-controls="products-cards-slider-slides"
          aria-label="Næste"
        >
          <div class="kb-ui-icon kb-ui-icon--ui-chevron-up"></div>
        </button>
      </div>

      <div class="glide__track" data-glide-el="track" ref="root">
        <div
          class="glide__slides"
          aria-live="polite"
          id="products-cards-slider-slides"
        >
          <template v-for="(result, index) in results">
            <p
              class="glide__slide kb-products-cards-slider__card"
              role="group"
              aria-roledescription="karusselelement"
              :aria-label="`${index + 1} af ${results.length}`"
              :data-index="`${index}`"
            >
              <template v-if="result.isSpotCard">
                <SpotCardGrid :spotCardData="result" />
              </template>
              <template v-else>
                <component
                  :is="displayProperties.card"
                  :data="result"
                  :truncateSummary="truncateSummary"
                ></component>              
              </template>
            </p>
          </template>
        </div>
      </div>
    </div>

    <div class="kb-products-cards-slider__bottom">
      <template v-if="link.href">
        <a
          :href="link.href"
          :target="link.target"
          class="kb-products-cards-slider__bottom__link"
        >
          <span>
            {{ getLabel('productsCardsSliderLinkText') }}
          </span>
          <div class="kb-products-cards-slider__bottom__link-icon">
            <svg
              width="17"
              height="10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g stroke="#E8001D">
                <path d="m12.167 1 3.623 4-3.623 4" stroke-linejoin="round" />
                <path d="M11.746 5H0" />
              </g>
            </svg>
          </div>
        </a>
      </template>
    </div>
  </article>
</template>
